import { factory } from '../factory';
import { detectionEngineV1Adapter } from './engine-v1';
import { detectionStoreV1Adapter } from './store-v1';
import { detectionUserEditedV1Adapter } from './user-edited-v1';

/**
 * Converts `WorkerStoreSlice` to `GetFaceEngineResultsResponse`.
 */
export const detectionStoreToUserEditedAdapter = factory(
  detectionStoreV1Adapter()
);

/**
 * Converts detection engine results `GetFaceEngineResultsResponse` into `GetFaceEngineResultsResponse`.
 */
export const detectionEngineToStoreAdapter = factory(
  detectionEngineV1Adapter(),
  detectionUserEditedV1Adapter()
);
